
export class EngagementDropdownBinding
{
    
    Name?: string;
    Label?:string;
Id?:number;
}